import React from 'react';
import styles from './loading.scss';

const Loading = ({ active, text, children }) => {
  if(!active && children)
    return children

  return (
    <div>
      <div className="loading-container">
        <div className="loader"></div>
        {text && <div className="loading-info">{text}</div>}
      </div>
      {children && children}
    </div>
  );
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/layout/Loading.js